// src/utils/datetime.js

// 분 단위 오프셋: 운영(540=+9h), 로컬(0)
export const DISPLAY_OFFSET_MIN = Number(
  process.env.REACT_APP_DISPLAY_OFFSET_MIN || "0"
);

// 표시용 타임존: 운영은 'Asia/Seoul', 로컬은 'UTC'로 사용할 예정
export const FORCE_TZ = process.env.REACT_APP_FORCE_TZ || "Asia/Seoul";

/** 입력을 Date로 정규화(타임존 없으면 UTC로 간주) */
export function toDateAssumingUTC(input) {
  if (!input) return null;
  if (input instanceof Date) return input;
  if (typeof input === "number") return new Date(input);

  let str = String(input).trim();

  if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}(\.\d+)?$/.test(str)) {
    str = str.replace(" ", "T").replace(/\.\d+$/, "");
  }
  const hasTZ = /[zZ]|[+-]\d\d:?\d\d$/.test(str);
  if (!hasTZ && /^\d{4}-\d{2}-\d{2}T\d{2}:\d{2}:\d{2}$/.test(str)) {
    str += "Z";
  }

  const d = new Date(str);
  return Number.isNaN(d.getTime()) ? null : d;
}

// 정렬용 ms (운영에서는 +9h 가산, 로컬은 0)
export function toMillisForSort(input) {
  const d = toDateAssumingUTC(input);
  if (!d) return -Infinity;
  return d.getTime() + DISPLAY_OFFSET_MIN * 60_000;
}

/** 화면 표시용 포맷 (타임존/오프셋 모두 환경변수로 제어) */
export function fmtKST(input, withSeconds = true) {
  const base = toDateAssumingUTC(input);
  if (!base) return "";
  const d = new Date(base.getTime() + DISPLAY_OFFSET_MIN * 60_000);

  const opt = {
    timeZone: FORCE_TZ,          // ← 하드코딩 대신 환경변수 사용
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    hour12: true,
  };
  if (withSeconds) opt.second = "2-digit";

  const parts = new Intl.DateTimeFormat("ko-KR", opt).formatToParts(d);
  const pick = (t) => parts.find((p) => p.type === t)?.value ?? "";

  const ap = pick("dayPeriod");
  const yy = pick("year"), mm = pick("month"), dd = pick("day");
  const hh = pick("hour"), mi = pick("minute"), ss = pick("second") || "00";

  return `${yy}-${mm}-${dd} ${ap} ${hh}시 ${mi}분${withSeconds ? ` ${ss}초` : ""}`;
}

// 기존 이름 유지
export const parseISOAssumingUTC = toDateAssumingUTC;
